import type {InvoiceMonth} from '../../types';
import type {TabsItem} from '@ds/components';

import {Tabs} from '@ds/components';
import {useMemo} from 'react';

type MonthSelectorProps = {
  items: InvoiceMonth[];
  selectedMonth: number;
  onSelect: (month: number) => void;
};

const MonthSelector: React.FC<MonthSelectorProps> = ({items, selectedMonth, onSelect}) => {
  const tabs = useMemo<TabsItem[]>(
    () =>
      items.map((item) => ({
        key: item.value.toString(),
        label: item.title
      })),
    [items]
  );

  return (
    <Tabs
      items={tabs}
      activeKey={selectedMonth.toString()}
      onChange={(key) => onSelect(Number(key))}
    />
  );
};

export default MonthSelector;
